import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CoreService } from '../../shared/services/core.service';
import { WebArticle } from '../../shared/entities/web-article';
import { AppState, AppUserState } from 'src/app/shared/stores/states/app.state';
import { SubscriptionsManager } from 'src/app/shared/helpers/subscriptions-manager';
import { Store, select } from '@ngrx/store';
import { selectCurrentUser } from 'src/app/shared/stores/selectors/user.selectors';
import { environment } from 'src/environments/environment';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UserOnboardingService } from 'src/app/shared/services/user-onboarding.service';
import { UserSettingsService } from 'src/app/shared/services/user-settings.service';
import * as UserActions from 'src/app/shared/stores/actions/user.actions';
import { isAllowedRubiRole } from 'src/app/shared/constants/rubi-allowed-roles';
import { TourManagerActions } from 'src/app/shared/stores/actions/tour-manager.actions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly DEFAULT_AVATAR_COLOR = '#3B82F6';

  isDropdownOpen = false;
  currentUser!: AppUserState;
  currentTheme: string = '';
  environment = environment;
  userMenuOpen = false;
  version = environment.version;


  get avatarBgColor(): string {
    return this.currentUser?.settings?.avatarBgColor || this.DEFAULT_AVATAR_COLOR;
  }

  get canChangeAvatarColor(): boolean {
    return isAllowedRubiRole(this.currentUser?.role ?? '');
  }


  showResults = false;
  inputFocused = false;

  results: WebArticle[] = [];
  searchTerm = '';

  private subsManager = new SubscriptionsManager();
  constructor(
    private store: Store<AppState>,
    private themeService: ThemeService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private coreService: CoreService,
    private ngxCookieService: CookieService,
    private userOnboardingService: UserOnboardingService,
    private userSettingsService: UserSettingsService
  ) {

    this.currentTheme = this.themeService.getCurrentThemeName();

    this.subsManager.add(
      this.themeService.themeChanged$.subscribe(() => {
        this.currentTheme = this.themeService.getCurrentThemeName();
        this.cdr.detectChanges();
      })
    );

  }
  ngOnInit(): void {
    this.subsManager.add(
      this.store
        .pipe(select(selectCurrentUser))
        .subscribe((currentUser: AppUserState) => {
          if (currentUser) {
            this.currentUser = currentUser;
          }
        }),
    );
  }

  ngOnDestroy(): void {
    this.subsManager.unsubscribeAll();
  }
  logout() {

    localStorage.clear();
    sessionStorage.clear();
    this.ngxCookieService.delete('uam-id-token', "/", environment.cookieInfo.domain);
    this.ngxCookieService.delete('uam-refresh-token', "/", environment.cookieInfo.domain);
    this.ngxCookieService.delete('uam-device-key', "/", environment.cookieInfo.domain);
    document.location.href = environment.uamUrl.trim() + 'auth/logout';

  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  onSearch($event: any) {
    if (!$event.target.value.length) {
      return;
    }
    this.searchTerm = $event.target.value;
    this.coreService.search(this.searchTerm).then((data) => {
      this.results = data.map((d: any) => d._source as WebArticle);
      this.showResults = true;
    });
  }
  clearSearch() {
    this.searchTerm = '';
    this.results = [];
    this.showResults = false;
    this.inputFocused = false;
  }
  onInputBlur() {
    this.showResults = false;
  }
  goHome() {
    this.router.navigateByUrl('/');
  }
  goToApplicationsLauncher() {
    window.location.href = environment.uamUrl;
  }
  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
  }
  getUserInitials(): string {
    if (!this.currentUser?.name) return '';

    const firstName = this.currentUser.name.charAt(0);
    const lastName = this.currentUser.lastName
      ? this.currentUser.lastName.charAt(0)
      : '';

    return (firstName + lastName).toUpperCase();
  }
  openAvatarColorModal() {
    this.userOnboardingService.openOnboardingModal(this.currentUser, { onlyColor: true }).subscribe({
      next: async (selectedColor) => {
        if (selectedColor) {
          const userSettings = this.currentUser.settings || { avatarBgColor: this.DEFAULT_AVATAR_COLOR };
          try {
            await this.userSettingsService.save({
              ...userSettings,
              avatarBgColor: selectedColor,
            }).catch((error) => {
              console.error('Error saving avatar color:', error);
            });
            this.store.dispatch(UserActions.loadCurrentUser());
            const updatedSettings = await this.userSettingsService.getMe();
            const updatedUser = { ...this.currentUser, settings: updatedSettings };
            this.store.dispatch(UserActions.setCurrentUser({ currentUser: updatedUser }));
            this.currentUser = updatedUser;
            this.store.dispatch(UserActions.updateUserSettings({
              settings: { ...userSettings, avatarBgColor: selectedColor }
            }));
            this.cdr.detectChanges();
          } catch (error) {
            console.error('Error saving avatar color:', error);
          }
        }
      },
      error: (error) => {
        console.error('Error in avatar color modal:', error);
      }
    });
  }

  async startTour() {
    this.userMenuOpen = !this.userMenuOpen;
    const isOnRoot = this.router.url.split('?')[0] === '/';
    if (isOnRoot) {
      this.store.dispatch(TourManagerActions.setTourStart({ tourStart: true }));
    } else {
      await this.router.navigate([''], { queryParams: { tour: true } });
    }
  }
}
